module.exports = __webpack_public_path__ + "static/img/455.26c98476.png";